import React from "react";
import atoms from "../../../../atoms";
import constant from "../../../../../constants/constant";
import moment from "moment";

const { Input, Select, Button } = atoms

const Index = ({ handleChange, reportData ,storeData,submitIndividualMonth}: any) => {


    const buttonValidation = (date1: Date, date2: Date) => {
        const parsedDate1 = new Date(date1);
        const parsedDate2 = new Date(date2);

        if (!parsedDate1 || isNaN(parsedDate1.getTime())) {
            return true;
        }
        if (!parsedDate2 || isNaN(parsedDate2.getTime())) {
            return true;
        }

        if (!reportData?.report_format) {
            return true
        }

        if (!reportData?.store_id) {
            return true
        }

        return false
    };

    return (
        <>
            <div className="row">
                <div className="col-4" style={{color:"#000000"}}>
                    <Select
                        className={"w-100"}
                        options={storeData}
                        value={reportData.store_id}
                        onChange={(e: any) => handleChange("store_id", e)}
                        placeholder={"Select"}
                        label={"Select Stores"} />
                </div>
                <div className="col-4">
                    <Input label={"Start Month"}
                        placeholder={"Start Month"} type="month"
                        value={reportData?.month_from}
                        onChange={(e: any) => {
                            handleChange("month_from", e?.target?.value)
                        }}
                    />
                </div>
                <div className="col-4">
                    <Input label={"End Month"}
                        placeholder={"Enter End Month"} type="month"
                        value={reportData?.month_to}
                        onChange={(e: any) => {
                            handleChange("month_to", e?.target?.value)
                        }}
                    />
                </div>
            </div>
            <div className="row mt-4">
                <div className="col-4" style={{color:"#000000"}}>
                    <Select
                        className="w-100"
                        options={constant.DailyReportFormat}
                        value={reportData?.report_format}
                        onChange={(e: any) => handleChange("report_format", e)} placeholder={"Select"}
                        label={"Select Report Format"} />
                </div>
            </div>
            <div className="d-flex justify-content-center" style={{ marginTop: "10rem" }}>
                <Button
                    isDisabled={buttonValidation(reportData?.month_from, reportData?.month_to)}
                    style={{ minWidth: "259px" }}
                    onClick={()=>submitIndividualMonth()}>Submit
                </Button>
            </div>
        </>
    )
}

export default Index